/**
 * Default config for the CDN.
 */
export const defaultCdnConfig = {
    bucketName: "shortcircuit-cdn-prod",
    baseUrl: `https://shortcircuit-cdn.flux.ai`,
};
//# sourceMappingURL=constants.js.map